import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import request from 'superagent';
import { ProgressBar } from 'react-bootstrap';
import classNames from 'classnames';
import _ from 'lodash';

export default class RocketMatterClientSelector extends React.Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    connectionId: PropTypes.number.isRequired,
  };

  state = {
    isLoading: false,
    isRefreshing: false,
  };

  async componentDidMount() {
    this.loadClients(false);
  }

  render() {
    const { isLoading, isRefreshing, clientSelectOptions } = this.state;

    if (isLoading && !clientSelectOptions) return (
      <ProgressBar now={100}/>
    );

    const refreshClasses = classNames({
      'fa': true,
      'fa-refresh': true,
      'fa-spin': isRefreshing,
    })

    return (
      <div key="self" style={{position: 'relative'}}>
        <Select
          defaultOptions
          options={this.state.clientSelectOptions}
          isClearable
          simpleValue
          disabled={isLoading}
          {...this.props}
        />
        <i className={refreshClasses}
           style={{
             position: 'absolute',
             textAlign: 'center',
             top: '12px',
             right: '27px',
             zIndex: 100,
             cursor: 'pointer',
           }}
           onClick={() => this.loadClients(true)}
           key="client-refresh-button"
        />
      </div>
    );
  }

  async loadClients(refresh) {
    const { connectionId } = this.props;

    this.setState({
      isLoading: true,
      isRefreshing: refresh,
    });

    const res = await request
      .get(`/rpc/integrations/connections/${connectionId}/rocketmatter/clients`)
      .query({ refresh: refresh });

    const clientSelectOptions = _.get(res.body, 'Clients', []).map(
      val => ({ label: val.Code, value: val.ContactID })
    );

    this.setState({
      isLoading: false,
      isRefreshing: false,
      clientSelectOptions
    });
  }
};

/**
 * FinalForm adaptor
 */
export const FinalFormRocketMatterClientSelector = ({ input: { value, onChange }, ...rest }) => {
  return (
    <RocketMatterClientSelector
      value={value}
      onChange={selectedOption => onChange(selectedOption)}
      {...rest}
    />
  );
};



// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/RocketMatter/RocketMatterClientSelector.jsx